module.exports = __webpack_public_path__ + "img/ripple.12169452.svg";